import { getGridStringOperators } from '@mui/x-data-grid-pro';
import { CHECKIN_SOURCES } from './utils';

// Text operators the Trip Users endpoint filters on (CP-7550). "is any of" is left out:
// the server would match it exactly and case-sensitively, which the grid does not say.
const SERVER_TEXT_OPERATORS = ['contains', 'equals', 'startsWith', 'endsWith', 'isEmpty', 'isNotEmpty'];

export const serverTextOperators = () => getGridStringOperators().filter((o) => SERVER_TEXT_OPERATORS.includes(o.value));

// The backend's CHECKIN_SOURCE_NONE: a booking without a check-in tag, which the
// column shows as "Not pre-checked-in".
export const CHECKIN_SOURCE_NONE = 'none';

export const checkinSourceFilterOptions = () => [
    ...Object.keys(CHECKIN_SOURCES).map((x) => ({ value: +x, label: CHECKIN_SOURCES[x] })),
    { value: CHECKIN_SOURCE_NONE, label: 'Not pre-checked-in' },
];
